import { resolveApiErrorMessage } from '@formosa/shared/i18n/resolveApiErrorMessage';

/** Canonical backend REASONS — do not invent FE-only values. */
export const MEMBER_REPORT_REASONS = Object.freeze([
  'SPAM',
  'HARASSMENT',
  'HATE_OR_ABUSE',
  'SEXUAL_CONTENT',
  'VIOLENCE',
  'SCAM_OR_FRAUD',
  'IMPERSONATION',
  'PRIVACY',
  'MISINFORMATION',
  'OTHER',
]);

export const REPORT_NOTE_MAX_LENGTH = 1000;

export function newSafetyClientRequestId(prefix = 'safety') {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function safetyErrorMessage(cause, t, fallbackKey = 'travel.safety.actionFailed') {
  if (typeof t !== 'function') {
    return resolveApiErrorMessage(cause, (key) => key, fallbackKey);
  }
  return resolveApiErrorMessage(cause, t, fallbackKey);
}

export function canShowMemberSafetyActions({ actorMemberId, targetMemberId }) {
  if (targetMemberId == null || targetMemberId === '') return false;
  if (actorMemberId == null || actorMemberId === '') return true; // anonymous: show CTA → auth gate
  return String(actorMemberId) !== String(targetMemberId);
}
